function kolonaMarquee() {
  const lines = document.querySelectorAll('.js-marquee-line');
  const windowWidth = window.innerWidth;
  if (lines) {
    lines.forEach((line, index) => {
      let totalWidth = 0;
      const accum = document.createElement('div');
      if (line.children) {
        [...line.children].forEach((inner) => {
          const computedStyle = window.getComputedStyle(inner);
          const marginRight = parseFloat(computedStyle.marginRight);
          const widthWithMargin = marginRight + inner.offsetWidth;
          if (totalWidth < windowWidth) {
            accum.appendChild(inner.cloneNode(true));
          }
          totalWidth += widthWithMargin;
        });
      }
      line.style.width = `${totalWidth + windowWidth}px`;
      line.style.overflow = 'hidden';
      [...accum.children].forEach((item) => {
        item.classList.add('cloned');
        line.append(item);
      });
      const bounceOptions = {
        duration: Math.floor(Math.random() * (700000 - 100000 + 1)) + 100000,
        easing: 'linear',
        iterations: Infinity,
      };
      const distance = totalWidth;
      const bounceKeyframes = [
        { transform: 'translateX(0px)' },
        { transform: `translateX(${index % 2 === 0 ? -distance : distance}px)` },
      ];
      line.animate(bounceKeyframes, bounceOptions);
    });
  }
}

export default kolonaMarquee;
